import { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'

import { useAnalyticsClient } from '@acorns/web-utils'

export const ACTIONS = {
  SCREEN_VIEW: 'Screen Viewed',
  CONTAINER_VIEWED: 'Container Viewed',
}

type AnalyticsOptionsInput = {
  action?: string
  threshold?: number
  payload?: object
  generatedPayload?: [string, object]
}
type HookReturnRef = (node?: Element | null | undefined) => void

const getPlatform = (): string => {
  let platform = ''

  if (!platform) {
    platform = /iPhone|iPod|Android/i.test(navigator.userAgent)
      ? 'mobile'
      : 'desktop'
  }

  return platform
}

const useAnalyticsComponentViewed = ({
  action: manualAction,
  threshold,
  payload: manualPayload,
  generatedPayload,
}: AnalyticsOptionsInput): HookReturnRef => {
  const [hasFired, setHasFired] = useState(false)
  const analytics = useAnalyticsClient()
  const { ref: inViewContainerRef, inView } = useInView({
    threshold: threshold || 0.8,
    triggerOnce: true,
  })

  const action = generatedPayload ? generatedPayload[0] : manualAction
  const payload = generatedPayload ? generatedPayload[1] : manualPayload

  useEffect(() => {
    if (!hasFired && inView) {
      analytics.track(action || ACTIONS.SCREEN_VIEW, {
        platform: getPlatform(),
        ...payload,
      })

      setHasFired(true)
    }
  }, [action, analytics, hasFired, inView, payload])

  return inViewContainerRef
}

export default useAnalyticsComponentViewed
